import type { STBookingMetaData } from "@stss/types";

function STBookingMeta({
  meta,
  bookingId,
  isReviewing = false,
}: {
  meta: STBookingMetaData | null;
  bookingId: number;
  isReviewing?: boolean;
}) {
  if (!meta) return null;
  return (
    <div className="text-sm">
      <p>{`Source: ${meta.source || "-"} | Platform: ${meta.platform || "-"}.`}</p>
      {meta?.reviewers && Array.isArray(meta?.reviewers && !isReviewing) ? (
        <>
          <p>Reviewers:</p>
          <ul>
            {meta.reviewers.map((email) => (
              <li key={email}>
                <a
                  className="hover:text-blue-500"
                  title="Send mail to reviewer"
                  href={`mailto:${email}?subject=STSS%20Invite%20for%20review${bookingId}&body=STSS%20Invite%20to%20the%20visit%20${bookingId}`}>
                  {email}
                </a>
              </li>
            ))}
          </ul>
        </>
      ) : null}
    </div>
  );
}

export default STBookingMeta;
